export default __webpack_public_path__ + "static/media/yellowlogo.dd1898e1.svg";